{
  "1000Plants": "1000+ plants in database",
  "1000PlantsDescription": "Add plants from the database, use plant information and care suggestions",
  "actions": "Actions",
  "add": "Add",
  "apply": "Apply",
  "applyGardenPlanTitle": "Apply the plan \"{planName}\" to the project?",
  "applyGardenPlanDescription": "The plan's plants will be moved to the main project, and the plan will be deleted.",
  "addCollection": "Add collection",
  "addEvent": "Add event",
  "addFromPlantDatabase": "Add plant from Database",
  "addingNewPlant": "Adding new plant",
  "addingNewTask": "Adding new task",
  "additionalCareSteps": "Additional care steps",
  "addNewEvent": "Add new event",
  "addNewTask": "Add new task",
  "addPlant": "Add plant",
  "addPlantSpecimen": "Add plant specimen",
  "addTask": "Add task",
  "advantages": "Advantages",
  "advicePlotMapFirst": "Tip: For more precise plot placement, display a map. Map usage can be enabled in Step 1.",
  "afterDiggingThePlantWillBeTransferredToTheUnplantedOnes": "After digging, the plant will be transferred to the unplanted ones.",
  "afterRemovingThePlantWillBeTransferredToTheUnplantedOnes": "After digging, the plant will be transferred to the unplanted ones.",
  "allNews": "All news",
  "allPlannedTasks": "All planned tasks",
  "allProjects": "All projects",
  "allReminders": "All reminders",
  "allTutorials": "All tutorials",
  "allUsefulMaterials": "All useful materials",
  "appearance": "Appearance",
  "applicationInDesign": "Application in design",
  "applyingFertilizer": "Applying fertilizer",
  "areYouSureYouWantToDelete": "Are you sure you want to delete?",
  "areYouSureYouWantToDeleteThisPlan": "Are you sure you want to delete this plan variant?",
  "areYouSureYouWantToDeleteThisCollection": "Are you sure you want to delete this collection?",
  "areYouSureYouWantToDeleteThisType": "Are you sure you want to delete this type?",
  "areYouSureYouWantToDeleteThisEvent": "Are you sure you want to delete this event?",
  "areYouSureYouWantToDigUpAllTheSpecimensOfThisPlant": "Are you sure you want to dig up all the specimens of this plant?",
  "areYouSureYouWantToFinish": "Are you sure you want to finish task?",
  "areYouSureYouWantToMakeSnapshot": "Are you sure you want to make snapshot?",
  "attitudeToLight": "Attitude to light",
  "basePlant": "Base plant",
  "basePlant-tooltip": "When you select a base plant, your plant's fields will be updated with information from the TerraSketch database associated with that plant. You can add to or edit this information. Changes you make are visible only to you.",
  "building": "Building",
  "buildingPlural": "Buildings",
  "bush": "Bush",
  "bushPlural": "Bushes",
  "bushCat": "Bushes and grasses",
  "bushCatPlural": "Bushes and grasses",
  "byClickingLogInWithGoogle": "By clicking Log in with Google above, you acknowledge that you have read and understood, and agree to ",
  "byClickingSignUpWithGoogle": "By clicking Sign up with Google above, you acknowledge that you have read and understood, and agree to ",
  "cancel": "Cancel",
  "canvasDataDescriptionSeparatlyGrowing": "having a record in the list of plants and a model on the plan",
  "canvasDataDescriptionSolitariusTemplates": "can be linked to a plant record by clicking on ",
  "canvasDataDescriptionOther": "Other site elements",
  "care": "Care",
  "careDifficulty": "care difficulty",
  "carePlan": "Care plan",
  "category": "Category",
  "center": "Center",
  "changeBasePlant": "Change base plant",
  "changePassword": "Change password",
  "changeProjectLocation": "Change project location",
  "characteristics": "Characteristics",
  "checkAllPlantsFromTheCollection": "Check all plants from the collection",
  "checkYourEmail": "Please check your email to continue.",
  "chooseMode": "Choose mode",
  "chooseObjectType": "Choose object type",
  "chooseObjectForm": "Choose object form",
  "choosePlotType": "Choose plot type",
  "chooseProjectImage": "Choose project image",
  "chooseType": "Choose type",
  "clearBasePlant": "Cleare base plant",
  "clearBasePlantMatchingFields": "Clear also fields pre-filled based on this base plant",
  "clearFilters": "Clear filters",
  "clearSorting": "Clear sorting",
  "closeEvent": "Close event",
  "cm": "cm",
  "collections": "Сollections",
  "collections-tooltip": "collections",
  "combineElementWithPlant": "Combine an element with a plant",
  "comment": "Comment",
  "commonInfo": "Common info",
  "completedActions": "Completed actions",
  "confidenceInPlantVariety": "Confidence in plant variety",
  "confirm": "Confirm",
  "confirmClearBasePlant": "Do you really want to clear the base plant",
  "confirmFormCloseTitle": "Do you really want to close the plant editing form?",
  "contacts": "Contact us",
  "continue": "Continue",
  "continueWithoutSaving": "Continue without saving",
  "court": "Court",
  "createATaskListAssociatedWithTheProjectAndEnterTheFirstTask": "Create a task list associated with the project and enter the first task",
  "createElement": "Create",
  "createNewProject": "Create new project",
  "createFirstProject": "Create your first project",
  "createFirstTask": "Create your first task",
  "createFromTemplate": "Create from template",
  "createTheFirstPlantInTheProject": "Create the first plant in the project",
  "createPolygonPlot": "Create polygon plot",
  "createYourFirstProjectDescription1": "For ease of work in TerraSketch, everything is organized within projects.",
  "createYourFirstProjectDescription2": "To get started, you just need to create a new project. You yourself determine what is meant by the project. This could be a plot, a house, a separate flower bed, and so on.",
  "createYourFirstProjectDescription3": "You can work with each project separately, create a plan for placing objects, mark planting locations, and plan tasks. In the Reminders, Plants, Journal sections you can work with a summary of data for all projects at once.",
  "createYourFirstProjectDescription4": "We recommend starting with the maximum scale of the project (for example, the entire site), and then, if necessary, separating individual parts into different projects.",
  "creatingOfNewProject": "Creating of New Project",
  "critical": "critical",
  "date": "Date",
  "dateOfEvent": "Date of event",
  "dateOfPlanting": "Date of planting",
  "dateOfPlantingUtc": "Date of planting",
  "dateRange": "Date range",
  "defaultProjectWithoutPlans": "Default project (without plans)",
  "delete": "Delete",
  "deleteAccount": "Delete account",
  "deleteElement": "Delete",
  "deleteEvent": "Delete the event",
  "deletePlant": "Delete plant",
  "deletePlantConfirm": "Do you really want to delete this plant?",
  "deletePlantEventsConfirm": "Also delete from the journal all events associated with this plant",
  "deletePlantFromToDoConfirm": "The reference to this plant will be removed from the tasks.",
  "deleteProject": "Delete project",
  "deleteProjectWithPlantsAndEventsConfirm": "Also delete from the journal all events associated with these plants",
  "deleteProjectWithPlantsConfirm": "Also delete all plants associated with this project",
  "description": "Description",
  "digUpAllPlantSpecimens": "Dig up all plant specimens",
  "digUpPlant": "Dig up the plant",
  "disadvantages": "Disadvantages",
  "disease": "Disease",
  "doYouReallyWantToDelete": "Do you really want to delete",
  "doYouReallyWantToDeleteThisAccount": "Do you want to delete this account?",
  "doYouWantToSaveTheProjectBeforeMovingOnToTheNextStep": "Do you want to save the project before moving on to the next step? Unsaved changes will be lost.",
  "draw": "Draw",
  "duplicatePlant": "Duplicate plant",
  "edge": "Edge",
  "edibility": "Edibility",
  "edit": "Edit",
  "editedInAnotherStep": "The selected element is edited in another step",
  "editElement": "Edit",
  "editGardenPlan": "Rename plan variant",
  "editingPlant": "Plant editing",
  "editor": "Plot editor",
  "editPlant": "Edit plant",
  "editProject": "Edit project",
  "editStepDefGenInfo": "Enter general information about the project.",
  "editStepDefPlot": "Create a plot base.",
  "editStepDefSoftscape": "Create softscape elements.",
  "editStepDefBuildings": "Create buildings and fences.",
  "editStepDefHardscape": "Create hardscape elements.",
  "editStepDefLargePlants": "Place large plants.",
  "editStepDefWaterscape": "Create waterscape elements.",
  "editStepDefSolitarius": "Place individual plants.",
  "editStepDefOtherElements": "Create other elements.",
  "editTask": "Edit task",
  "ellipse": "Ellipse",
  "email": "Email",
  "emailIsIncorrect": "The value entered is not a valid email address.",
  "emailUs": "Email us",
  "endDate": "End date",
  "enterObjectName": "Enter object name",
  "enterProjectLocation": "Enter project location",
  "enterPlotEdgesDimensions": "Enter plot edges dimensions",
  "enterResetEmail": "Enter your email to reset your password",
  "entrance": "Entrance",
  "entrancePlural": "Entrances",
  "errorDuringLogin": "Login error",
  "eventCategory": "Event category",
  "eventEndDate": "Event end date",
  "eventInfo": "Event info",
  "eventName": "Name of event",
  "eventPhotos": "Photos",
  "eventType": "Type of event",
  "failedToDeleteTask": "failed to delete task",
  "family": "Family",
  "familyRu": "Family (ru)",
  "familyLa": "Family",
  "faq": "Frequently Asked Questions",
  "faqAnswer1": "The basic functionality of the product is free for all users. There are paid plans that add additional features, such as uploading more of your photos.",
  "faqAnswer2": "The plant database is filled in by our experts and is updated daily with new specimens. All photographs posted in the plant database represent unique content, obtained by the product developers and belong to the copyright holder of the product.",
  "faqAnswer3": "At the moment, the mobile application is under development. Users have access to a mobile version of the site, adapted for use on small screens.",
  "faqAnswer4": "User data belongs exclusively to users, is stored on the server, is not used in the product's plant database, and is not available to other users.",
  "faqQuestion1": "Is the product paid?",
  "faqQuestion2": "Where does the information in the plant database come from?",
  "faqQuestion3": "Is there a mobile application TerraSketch?",
  "faqQuestion4": "How my data is used and who has access to it?",
  "featuresOfCultivation": "Features of cultivation",
  "featuresOfFruitStorage": "Features of fruit storage",
  "featuresOfStoringPlantingMaterial": "Features of storing planting material",
  "fence": "Fence",
  "fertilizerFrequency": "Fertilizer frequency",
  "fertilizers": "Fertilizers",
  "fieldIsRequired": "The field {field} is required",
  "filter": "Filter",
  "filters": "Filters",
  "filtersAndSorting": "Filters and sorting",
  "filtersUp": "Filters",
  "finish": "Finish",
  "finishTask": "Finish task",
  "finishToDo": "Finish ToDo and put it in journal",
  "flowerbed": "Flowerbed",
  "flowerbedPlural": "Flowerbeds",
  "flowerCat": "Flowers",
  "flowerColor": "Flower color",
  "flowersPhotos": "Flowers photos",
  "flowerSize": "Flower size",
  "forgotPassword": "Forgot password",
  "formModifiedButNotSaved": "Plant was modified, but not saved.",
  "from": "from",
  "from2": "from",
  "fruiting": "Fruiting",
  "fruitingTime": "Fruiting time",
  "fruitMass": "Fruit mass",
  "fruitsPhotos": "Fruits photos",
  "furniture": "Furniture",
  "furniturePlural": "Furniture",
  "g": "g",
  "cards": "Cards",
  "gallery": "Gallery",
  "garden": "Garden",
  "gardenPlan": "Garden plan",
  "gardenPlanVariantsHint": "Plan variants let you add planned but not yet planted vegetation and compare different planting options. Only one variant can be displayed at a time. A variant can be applied to the project, at which point it becomes part of it.",
  "gardeningWork": "Gardening work",
  "gardenPlural": "Gardens",
  "gardenJournal": "Garden Journal",
  "gardenJournalDescription": "Keep records of your plants and their growth history over many years",
  "greenhouse": "Greenhouse",
  "growing-conditions": "Growing conditions",
  "growthRate": "Growth rate",
  "home": "Home",
  "hedge": "Hedge",
  "hedgePlural": "Hedges",
  "height": "Height",
  "hideElementOnSitePlan": "Hide element on site plan",
  "hideGardenPlanVariantPlants": "Hide plants from plan variants",
  "hidePlantOnSitePlan": "Hide plant on site plan",
  "ifYouDontHaveAccount": "If you don't have account ",
  "ifYouHaveAccount": "If you already have an account ",
  "importance": "Importance",
  "informationAboutWhichPlantsBelongedToThisCollectionWillAlsoBeRemoved": "Information about which plants belonged to this collection will also be removed.",
  "isRequired": "is required",
  "journal": "Journal",
  "landingPlantHydrangea": "Bigleaf hydrangea Madame Emile Mouillere",
  "landingPlantBerberis": "Japanese barberry Admiration",
  "landingPlantSymphotrichum": "Aster dumosus",
  "landingPlantCrocus": "Crocus",
  "landingPlantDasiphora": "Dasiphora fruticosa Pink Beauty",
  "landingPlantAnemone": "Anemone hybrida",
  "landingPlantSedum": "Hylotelephium spectabile",
  "lastWeek": "Last week",
  "lastMonth": "Last month",
  "last90days": "Last 90 days",
  "lastYear": "Last year",
  "leafColor": "Leaf color",
  "leafPhotos": "Leaf photos",
  "length": "Length",
  "lifeCycle": "Life cycle",
  "lighting": "Lighting",
  "lightingPlural": "Lighting",
  "location": "Location",
  "locationPlant": "Location",
  "locationReference": "Location - reference to geographic coordinates",
  "locationReferenceInfo": "You can use the project location to add a terrain map to your project and display the current weather conditions in your area.",
  "logIn": "Log in",
  "logInWithGoogle": "Log in with Google",
  "logOut": "Log out",
  "low": "low",
  "lawn": "Lawn",
  "lawnPlural": "Lawns",
  "m": "m",
  "mainInfo": "Main info",
  "makeSnapshot": "Make snapshot",
  "makingSnapshotDescription": "A project snapshot is an unedited copy of a project as of a specific date. The copy contains a list of sites and plants located on the project.",
  "mapCoordinatesWillBeReset": "Map coordinates will be reset",
  "mapNotFound": "Map not found. Save the map in step 1 of editing the project.",
  "medicalProperties": "Medical properties",
  "meter": "meter(s)",
  "metricSystem": "Metric system",
  "myCollections": "My collections",
  "myPhotos": "My photos",
  "myPlants": "My plants",
  "myPlantTimeline": "My plant timeline",
  "myProjects": "My projects",
  "mySnapshots": "My snapshots",
  "myToDos": "My ToDos",
  "name": "Name",
  "nameOfTask": "Name of task",
  "next": "Next",
  "newCollection": "New collection",
  "newGardenPlan": "New plan variant",
  "newPassword": "New password",
  "news": "News",
  "newTaskAdding": "New task adding",
  "newTaskList": "Create new task list",
  "newTypeName": "New type name",
  "newList": "New List",
  "no": "no",
  "noEntries": "no entries",
  "noInformationAboutProjectLocation": "no information about project location",
  "normal": "normal",
  "noTemplatesForThisType": "There are no templates for this type",
  "noTitle": "no title",
  "notPlanted": "not planted",
  "nowUsingBasePlant": "Base plant used",
  "objectName": "Object name",
  "objectParameters": "Object parameters",
  "objectType": "Object type",
  "onElement": "on element",
  "onlineEditor": "Online plot editor",
  "onlineEditorDescription": "Create a plan for your plot and track planted plants on it",
  "openPlantDescription": "Open plant description",
  "other": "Other",
  "otherPlural": "Other",
  "otherNames": "Other names",
  "otherNews": "Other news",
  "otherSiteElements": "Other site elements",
  "overview": "Overview",
  "overwriteBasePlant": "Overwrite base plant",
  "password": "Password",
  "passwordMismatch": "Password mismatch",
  "pastEvents": "Past events",
  "pathway": "Pathway",
  "pathwayPlural": "Pathways",
  "patio": "Patio",
  "pesticides": "Pesticides",
  "pesticideTreatmentFrequency": "Pesticide Treatment Frequency",
  "pests": "Pests",
  "passwordValidation": "Use Latin letters (a–z, A–Z), at least one number, and at least 6 characters.",
  "photos": "Photos",
  "placeTheMap": "Place the map in the window so that it covers the entire territory that you need in the future for planning the site (the site itself, adjacent roads, etc.)",
  "plantFromGardenPlan": "The plant was added in the selected plan variant and is not part of the original project",
  "gardenPlanTag": "Plan",
  "plantIsCreatedInGardenPlan": "The plant is being created within the plan variant \"{planName}\"",
  "planningModeWarning": "You are in planning mode: plants will be saved within the selected plan variant without being added to the original project. You can't move plants from the original project in this mode.",
  "plannedCompletionDate": "Planned completion date",
  "plannedTasks": "Planned tasks",
  "plant": "Plant",
  "plant-health": "Plant health",
  "plantcomposition": "Plant composition",
  "plantcompositionPlural": "Plant compositions",
  "plantDatabase": "Plant database",
  "plantDesignationOnTheMap": "Designation on the map",
  "planted": "planted",
  "plantedDate": "Date of planting",
  "plantedIn": "Planted in the project",
  "plantedPlants": "Planted plants",
  "plantingAndReproduction": "Planting and reproduction",
  "plantingDepth": "Planting depth",
  "plantingSeedlingsInClosedGround": "planting seedlings in closed ground",
  "plantingSeedlingsInOpenedGround": "planting in opened ground",
  "plantingWork": "Planting work",
  "plantModelWithoutPlantRecord": "Plant model without plant record",
  "plantName": "Name of plant",
  "plantName-tooltip": "Name of plant",
  "plantPageWorkWithTodo": "Working with tasks from the plant page",
  "plantPhotos": "Photos",
  "plantPlant": "Plant the plant",
  "plants": "Plants",
  "plantsTaskList": "Other tasks related to plants",
  "plantTypeDistributionDiagram": "Plant type distribution diagram",
  "plotWillBeDeleted": "plot will be deleted",
  "policy": "Terms and Privacy Policy",
  "policyTerrasketch": "TerraSketch's Terms and Privacy Policy",
  "polygon": "Polygon",
  "pond": "Pond",
  "pool": "Pool/Pond",
  "preserveMapCoordinates": "Preserve map coordinates",
  "project": "Project",
  "projectChangedSaveBeforeProceedingToTheNextStep": "The project has been modified. Save before proceeding to the next step.",
  "projectComposition": "Project composition",
  "projectCoordinates": "Coordinates",
  "projectDescription": "Project description",
  "projectIsNotSaved": "The project contains unsaved changes.",
  "projectName": "Project name",
  "projectPage": "Project page",
  "projectPageTour": "How to work with the project?",
  "projectPageTourDescriptionAll": "On the project page, you can view individual elements of the project, add new plants and mark them on the plan.",
  "projectPageTourDescriptionEdit": "Switch to project editing mode. In this mode, it is possible to edit the project description, place new and edit already added site elements.",
  "projectPageTourDescriptionAddPlant": "When adding a new plant, you can use the information from the TerraSketch database as a basis, or you can create an entry from scratch.",
  "projectPageTourDescriptionCanvas": "Planting a plant means placing it on the project plan. To plant a plant, you need to add a record about it to the project, then select this record in the 'Unplanted Plants' tab and click the 'Plant the plant' button.",
  "projectPageTourDescriptionSnapshot": "You can save the current state of the site as a project snapshot. We recommend taking a photo at least once per season.",
  "projectPageTourDescriptionReminders": "The 10 most pressing tasks associated with this project are displayed. You work with the list of tasks on the To-Do Lists page.",
  "projects": "Projects",
  "projectOverview": "Project overview",
  "projectsOverview": "Projects overview",
  "projectSketch": "Project sketch",
  "projectSnapshot": "Project snapshot",
  "projectReminders": "Project reminders",
  "propagation-planting": "Propagation & Planting",
  "properties": "Properties",
  "purposeLocation": "Purpose/location",
  "putObjectOnThePlan": "Put object on the plan",
  "rect": "Rectangle",
  "reminders": "Reminders",
  "removePlantSpecimen": "Remove plant specimen",
  "repeatPassword": "repeat password",
  "repeatNewPassword": "Repeat new password",
  "replantPlant": "Replant the plant",
  "reproductionMethods": "Reproduction methods",
  "requiredField": "${label} is required!",
  "resetFilters": "Reset filters",
  "resetPassword": "Reset password",
  "ruler": "Ruler",
  "save": "Save",
  "saveAndContinue": "Save and continue",
  "saveEvent": "Save event",
  "searchForBasePlant": "Enter a name to search in the plant database",
  "searchForLocation": "Search for location",
  "searchForNews": "Search for news",
  "searchingPlantBase": "Searching in plant base",
  "seeAllProjects": "See all projects",
  "seeAllReminders": "See all reminders",
  "select": "Select",
  "selectAnObjectForEditing": "Select an object for editing",
  "selectAnElementForDeleting": "Select an element for deleting",
  "selectPlantsFromTheMarkedCollections": "Select plants from the marked collections",
  "selectPlantForConnection": "Select plant for connection with ",
  "selectPlantForConnectionNote": "Note: After clicking the 'OK' button, the display of all instances of the selected plant will change.",
  "selectTemplateOrDrawingTool": "Select template or drawing tool",
  "selectTheTaskCompletionDate": "Select the task completion date",
  "sendEmailToResetPassword": "Send an email to reset your password",
  "separatelyGrowing": "Separately growing",
  "showGridWithSpacing": "Show grid with spacing ",
  "showMap": "Show map",
  "showElementOnSitePlan": "Show element on site plan",
  "showPlantOnSitePlan": "Show plant on site plan",
  "side": "Side",
  "signUpWithGoogle": "Sign up with Google",
  "signUp": "Sign Up",
  "size-appearance": "Size & Appearance",
  "sloganElevate": "Elevate your gardening experience",
  "snapshot": "Snapshot",
  "snapshots": "Snapshots",
  "soil": "Soil (substrate)",
  "solitarius": "Solitarius",
  "sortBy": "Sort by",
  "sorting": "Sorting",
  "sortingBy": "Sorting by",
  "sortingDirectionAsc": "ascending",
  "sortingDirectionDesc": "descending",
  "specification": "specification",
  "spreading": "Spreading",
  "stairs": "Stairs",
  "stairsPlural": "Stairs",
  "startDate": "Start date",
  "startToday": "Start today",
  "step": "Step",
  "structure": "Garden structure",
  "structurePlural": "Garden structures",
  "subSloganElevate": "Discover TerraSketch, where we transform the way you plan and care for your garden. Our platform not only helps you visualize your dream garden but also supports you through every step of its growth. Start your journey with TerraSketch today and watch your garden flourish.",
  "table": "Table",
  "tag-news": "news",
  "tag-tutorials": "tutorials",
  "taskDeleting": "Task deleting",
  "taskDescription": "Task description",
  "taskEditing": "Task editing",
  "taskFinishing": "Task finishing",
  "taskPlanner": "Task planner",
  "taskPlannerDescription": "Make to-do lists for your areas and monitor the condition of your plants",
  "taxonomy": "Taxonomy",
  "taskAndEventFilters": "Task and event filters",
  "taskType": "Task type",
  "taskTypes": "Task types",
  "terrace": "Terrace",
  "terracePlural": "Terraces",
  "terraSketchEditor": "TerraSketch Online Editor",
  "terraSketchEditorDescription1": "Begin your gardening journey by creating a comprehensive plan for your plot",
  "terraSketchEditorDescription2": "Mark and catalog the plants you've introduced to your garden",
  "terraSketchEditorDescription3": "Use your planting history to organize proper crop rotations",
  "terraSketchEditorDescription4": "Estimate the volume of planting materials and consumables needed for your garden projects",
  "terraSketchEditorDescription5": "Save snapshots of your plot at specific dates to document how it grows and evolves over time",
  "terraSketchTaskPlanner": "TerraSketch Task Planner",
  "terraSketchTaskPlannerDescription1": "Create customized lists for your garden area, organizing tasks to align perfectly with your garden's unique requirements",
  "terraSketchTaskPlannerDescription2": "Keep a close eye on the health and condition of your plants",
  "terraSketchTaskPlannerDescription3": "Document the growth and development stages of your plants using specialized timelines",
  "terraSketchTaskPlannerDescription4": "Look back on your garden's history with the gardener's journal",
  "terraSketchPlantDatabase": "TerraSketch Plants Database",
  "terraSketchPlantDatabaseDescription": "Explore the heart of TerraSketch — our meticulously curated plant database, where over 1,000 entries await to inspire and guide your gardening journey. Each entry, crafted with care by our product developers, features photographs, detailed descriptions, and tailored care recommendations. Grow the garden of your dreams with TerraSketch, where every plant inspires and tells a story.",
  "theLatestPostsAndGuides": "The latest posts and guides. Select an article to read the full text.",
  "thePlantIsInTheProject": "The plant is in the project",
  "thePlantWasRemovedByTheUser": "The plant was removed by the user",
  "thisIsTheOnlyPlantedSpecimenOfThisPlant": "This is the only planted specimen of this plant.",
  "thisOperationIsIrreversible": "This operation is irreversible.",
  "thisOperationWillMoveTask": "This operation will move the task to the journal.",
  "thisMonth": "This month",
  "thisWeek": "This week",
  "tile": "Tile",
  "tilePlural": "Tiles",
  "timeForPlantingSeedlingsInClosedGround": "Time for planting seedlings in closed ground",
  "timeForPlantingSeedlingsInOpenedGround": "Time for planting seedlings in opened ground",
  "today": "Today",
  "todoGroup-overdue": "Overdue",
  "todoGroup-today": "Today",
  "todoGroup-tomorrow": "Tomorrow",
  "todoGroup-laterThisWeek": "Later this week",
  "todoGroup-laterThisMonth": "Later this month",
  "todoGroup-nextMonth": "Next month",
  "todoGroup-later": "Later",
  "todoGroup-noDate": "No date",
  "toDisplayWeather": "To display weather and related recommendations, enter the project location in settings",
  "todoLists": "To-Do Lists",
  "todoPage": "To-Do Page",
  "todoPageTour": "How to work with To-Do tasks?",
  "todoPageTourDescriptionAll": "На странице задач вы можете создавать, редактировать и просматривать задачи, связанные с растениями или другими работами.",
  "todoPageTourDescriptionAdd": "При создании новой задачи вы можете использовать один из стандартных типов (например, обрезка) или добавить свой. Типы помогают структурировать в дальнейшем жизненный цикл растения, а также группировать разные задачи по саду. Также вы можете связать создаваемую задачу с добавленными вами ранее растениями, задать желаемые сроки выполнения и первоочередность задачи.",
  "todoPageTourDescriptionList": "Все созданные ранее задачи отображаются на странице в виде карточек.",
  "todoPageTourDescriptionFilter": "Исользуйте фильтр и сортировку для повышения эффективности организации своей работы. Например, вы можете отобразить задачи, связанные только с конкретным растением или запланированные на ближайшие выходные.",
  "todoPageTourDescriptionEdit": "Для редактирования и просмотра более подробной информации о задаче нажмите на значок карандаша на карточке задачи.",
  "todoPageTourDescriptionEndTask1": "Чтобы успешно завершить задачу, нажмите на значок птички. При завершении укажите актуальную дату выполнения задачи и, при необходимости, исправьте тип выполненной задачи. ",
  "todoPageTourDescriptionEndTask2": "После завершения задача преобразовывается в событие, которое произошло в указанную вами дату. Если задача была привязана одновременно к нескольким растениям, то при завершении задачи произойдет создание события для каждого из перечисленных растений. ",
  "todoPageTourDescriptionEndTask3": "Вы можете всегда посмотреть список выполненных задач (событий) в Дневнике или на странице соответствующего связанного с задачей растения.",
  "todoPageTourDescriptionDeleteTask": "Удалить полностью задачу можно нажав на значок корзины. При этом задача не попадет в дневник, а будет удалена без возможности нахождения данной информации.",
  "todoPageTourDescriptionPlantPage": "Работать с задачами можно также со страниц добавленных вами растений. Вся информация о добавленных, отредактированных или завершенных таким способом задачах будет видна также и на странице Мои списки задач.",
  "totalPlantsInTheProject": "Total plants in the project",
  "toxicity": "Toxicity",
  "tree": "Tree",
  "treeCat": "Trees",
  "treeCatPlural": "Trees",
  "trimTime": "Trim time",
  "type": "Type",
  "typeOfTheCorrespondingTasksAndEventsWillBeChangedToGeneral": "The type of the corresponding tasks and events will be changed to General.",
  "unplantedPlants": "Unplanted plants",
  "uploadPhotos": "Upload photos",
  "uploadPlantPhotos": "Upload plant photos",
  "urgent": "urgent",
  "usage": "Usage",
  "uSDA": "USDA scale",
  "usefulMaterials": "Useful materials",
  "useMapForProjectCreating": "Use map for project creating",
  "useMyCurrentLocation": "Use my current location",
  "usePlotDrawingTool": "Use plot drawing tool",
  "userAccount": "User account",
  "userEmail": "User email",
  "userInfo": "User info",
  "userName": "User name",
  "userSettings": "User settings",
  "variety": "Variety",
  "varietyEng": "Variety",
  "vegetableCat": "Vegetables",
  "vegetableCatPlural": "Vegetables",
  "vegetablegarden": "Vegetable garden",
  "vegetablegardenPlural": "Vegetable gardens",
  "water": "Water - other elements",
  "waterPlural": "Water",
  "watering": "Watering",
  "width": "Width",
  "yes": "yes",
  "yourActionsCannotBeUndone": "Your actions cannot be undone",

  "metricSystemTooltip": "The metric system determines units, what measured values will be used in the application",
  "userNameTooltip": "The username is only used within the application for convenience",

  "commonName": "Common name",
  "scienceName": "Science name",
  "element": "Element",
  "heightFrom": "Height from (м)",
  "heightTo": "Height to (м)",
  "height-rangeField": "Height(м)",
  "spreadingFrom": "Spreading from (м)",
  "spreadingTo": "Spreading to (м)",
  "spreading-rangeField": "Spreading (м)",
  "flowerSize-rangeField": "Flower/inflorescence size (cm)",
  "attractionFactors": "Attraction factors",
  "bloomingTime": "Blooming time",

  "eventType-": " ",
  "eventType-planting": "planting",
  "eventType-repotting": "repotting",
  "eventType-propagation": "propagation",
  "eventType-seedsowing": "seed sowing",
  "eventType-seedlingsemerge": "seedlings emerge",
  "eventType-trueleaves": "true leaves",
  "eventType-prickingout": "pricking out",
  "eventType-hardeningoff": "hardening off",
  "eventType-transplanting": "transplanting",
  "eventType-harvesting": "harvesting",
  "eventType-pruning": "pruning",
  "eventType-weeding": "weeding",
  "eventType-fertilizing": "fertilizing",
  "eventType-blooming": "blooming",
  "eventType-watering": "watering",
  "eventType-chemicals": "chemicals",
  "eventType-general": "general",
  "eventType-buying": "buying",
  "eventType-preplanting": "preparing planting material",
  "eventType-winter": "preparing for winter",

  "uSDA-0": "0",
  "uSDA-1": "1",
  "uSDA-2": "2",
  "uSDA-3": "3",
  "uSDA-4": "4",
  "uSDA-5": "5",
  "uSDA-6": "6",
  "uSDA-7": "7",
  "uSDA-8": "8",
  "uSDA-9": "9",
  "uSDA-10": "10",
  "uSDA-11": "11",
  "uSDA-12": "12",

  "январь": "январь",
  "февраль": "февраль",
  "март": "март",
  "апрель": "апрель",
  "май": "май",
  "июнь": "июнь",
  "июль": "июль",
  "август": "август",
  "сентябрь": "сентябрь",
  "октябрь": "октябрь",
  "ноябрь": "ноябрь",
  "декабрь": "декабрь",
  "после минования угрозы заморозков": "после минования угрозы заморозков",

  "careDifficulty-низкая": "низкая",
  "careDifficulty-средняя": "средняя",
  "careDifficulty-высокая": "высокая",

  "purposeLocation-контейнерное": "контейнерное",
  "purposeLocation-комнатное": "комнатное",
  "purposeLocation-уличное": "уличное",
  "purposeLocation-сезонное": "сезонное",

  "lifeCycle-многолетнее": "многолетнее",
  "lifeCycle-двухлетнее": "двухлетнее",
  "lifeCycle-однолетнее": "однолетнее",

  "watering-частый": "частый",
  "watering-1 раз в неделю": "1 раз в неделю",
  "watering-2 раза в неделю": "2 раза в неделю",
  "watering-умеренный": "умеренный",
  "watering-редкий": "редкий",
  "watering-по мере необходимости": "по мере необходимости",
  "watering-не требует дополнительного полива": "не требует дополнительного полива",
  "watering-постоянно влажная почва": "постоянно влажная почва",

  "attitudeToLight-солнце": "солнце",
  "attitudeToLight-полутень": "полутень",
  "attitudeToLight-тень": "тень",
  "attitudeToLight-легкая полутень": "полутень",
  "attitudeToLight-рассеянный свет": "свет",
  "attitudeToLight-яркий рассеянный свет": "свет",

  "edibility-бутоны": "бутоны",
  "edibility-клубни": "клубни",
  "edibility-корни": "корни",
  "edibility-листья": "листья",
  "edibility-луковица": "луковица",
  "edibility-медицинские свойства": "медицинские свойства",
  "edibility-молодые побеги": "молодые побеги",
  "edibility-овощи": "овощи",
  "edibility-плоды": "плоды",
  "edibility-семена": "семена",
  "edibility-соцветия": "соцветия",
  "edibility-фрукты": "фрукты",
  "edibility-ягоды": "ягоды",

  "toxicity-все части": "все части",
  "toxicity-кора": "кора",
  "toxicity-корни": "корни",
  "toxicity-листья": "листья",
  "toxicity-плоды": "плоды",
  "toxicity-сок": "сок",
  "toxicity-стебель": "стебель",
  "toxicity-цветы": "цветы",
  "toxicity-ядовитое": "ядовитое",

  "type-вереск": "вереск",
  "type-водное": "водное",
  "type-вьющиеся и лианы": "вьющиеся и лианы",
  "type-дерево": "дерево",
  "type-кактусы и суккуленты": "кактусы и суккуленты",
  "type-клубнелуковичное": "клубнелуковичное",
  "type-кустарник": "кустарник",
  "type-луковичное": "луковичное",
  "type-пальмовые и саговниковые": "пальмовые и саговниковые",
  "type-папоротник": "папоротник",
  "type-плотоядное": "плотоядное",
  "type-полукустарник": "полукустарник",
  "type-травянистое": "травянистое",
  "type-цветущее": "цветущее",
  "type-небольшое дерево": "небольшое дерево",
  "type-эпифит": "эпифит",

  "attractionFactors-ампельное": "ампельное",
  "attractionFactors-быстрорастущее": "быстрорастущее",
  "attractionFactors-всесезонная декоративность": "всесезонная декоративность",
  "attractionFactors-гигрофит": "гигрофит",
  "attractionFactors-декоративная кора": "декоративная кора",
  "attractionFactors-декоративная форма кроны": "декоративная форма кроны",
  "attractionFactors-декоративное плодоношение": "декоративное плодоношение",
  "attractionFactors-декоративное цветение": "декоративное цветение",
  "attractionFactors-декоративнолиственное": "декоративнолиственное",
  "attractionFactors-ксерофит": "ксерофит",
  "attractionFactors-медленнорастущее": "медленнорастущее",
  "attractionFactors-морозостойкое": "морозостойкое",
  "attractionFactors-очищает воздух": "очищает воздух",
  "attractionFactors-плетущееся": "плетущееся",
  "attractionFactors-почвопокровное": "почвопокровное",
  "attractionFactors-привлекающее опылителей": "привлекающее опылителей",
  "attractionFactors-продолжительное цветение": "продолжительное цветение",
  "attractionFactors-съедобное": "съедобное",
  "attractionFactors-теневыносливое": "теневыносливое",
  "attractionFactors-тенелюбивое": "тенелюбивое",
  "attractionFactors-топиарные формы": "формы",
  "attractionFactors-хвойное": "хвойное",
  "attractionFactors-цветение в ранневесенний период": "цветение в ранневесенний период",
  "attractionFactors-экзотический внешний вид": "экзотический внешний вид",

  "featuresOfCultivation-необходима предварительная высадка на рассаду в закрытый грунт": "необходима предварительная высадка на рассаду в закрытый грунт",
  "featuresOfCultivation-возможна предвариательная высадка на рассаду": "возможна предвариательная высадка на рассаду",
  "featuresOfCultivation-предварительное проращиевание клубней": "предварительное проращиевание клубней",
  "featuresOfCultivation-стратификация посадочного материала": "стратификация посадочного материала",
  "featuresOfCultivation-дополнительная обработка посадочного материала": "дополнительная обработка посадочного материала",
  "featuresOfCultivation-есть период покоя": "есть период покоя",
  "featuresOfCultivation-возможен посев семян в грунт под зиму": "возможен посев семян в грунт под зиму",
  "featuresOfCultivation-скарификация семян при посадке весной": "скарификация семян при посадке весной",

  "reproductionMethods-боковыми побегами": "боковыми побегами",
  "reproductionMethods-делением клубня": "делением клубня",
  "reproductionMethods-делением корневища": "делением корневища",
  "reproductionMethods-делением куста": "делением куста",
  "reproductionMethods-клубнелуковицами": "клубнелуковицами",
  "reproductionMethods-клубнепочками": "клубнепочками",
  "reproductionMethods-листом": "листом",
  "reproductionMethods-луковицами": "луковицами",
  "reproductionMethods-луковичными чешуйками": "луковичными чешуйками",
  "reproductionMethods-отводками": "отводками",
  "reproductionMethods-прививкой": "прививкой",
  "reproductionMethods-семенами": "семенами",
  "reproductionMethods-спорами": "спорами",
  "reproductionMethods-частью листа": "частью листа",
  "reproductionMethods-черенкованием": "черенкованием",

  "timeForPlantingSeedlingsInOpenedGround-после минования угрозы заморозков": "после минования угрозы заморозков",

  "additionalCareSteps-обрезка на зиму": "обрезка на зиму",
  "additionalCareSteps-омолаживающая обрезка": "омолаживающая обрезка",
  "additionalCareSteps-поллардинг": "поллардинг",
  "additionalCareSteps-прищипывание": "прищипывание",
  "additionalCareSteps-санитарная обрезка": "санитарная обрезка",
  "additionalCareSteps-удаление увядших цветов": "удаление увядших цветов",
  "additionalCareSteps-укрытие на зиму": "укрытие на зиму",
  "additionalCareSteps-формовочная обрезка": "формовочная обрезка",
  "additionalCareSteps-хранение зимой в помещении": "хранение зимой в помещении",

  "applicationInDesign-аквариум": "аквариум",
  "applicationInDesign-аллея": "аллея",
  "applicationInDesign-альпийская горка (альпинарий)": "альпийская горка (альпинарий)",
  "applicationInDesign-балкон": "балкон",
  "applicationInDesign-берсо": "берсо",
  "applicationInDesign-бонсай": "бонсай",
  "applicationInDesign-бордюр": "бордюр",
  "applicationInDesign-в интерьере": "в интерьере",
  "applicationInDesign-вертикальное озеленение": "вертикальное озеленение",
  "applicationInDesign-гербарий": "гербарий",
  "applicationInDesign-групповая посадка": "групповая посадка",
  "applicationInDesign-декоративный мини-водоем": "декоративный мини-водоем",
  "applicationInDesign-живая изгородь": "живая изгородь",
  "applicationInDesign-кашпо": "кашпо",
  "applicationInDesign-клумба": "клумба",
  "applicationInDesign-контейнер": "контейнер",
  "applicationInDesign-кулисы": "кулисы",
  "applicationInDesign-миксбордер": "миксбордер",
  "applicationInDesign-мобильный прудик": "мобильный прудик",
  "applicationInDesign-оформление букета": "оформление букета",
  "applicationInDesign-пальметта": "пальметта",
  "applicationInDesign-рабатка": "рабатка",
  "applicationInDesign-рокарий": "рокарий",
  "applicationInDesign-солитер (одиночное)": "солитер (одиночное)",
  "applicationInDesign-срезка": "срезка",
  "applicationInDesign-сухой букет": "сухой букет",
  "applicationInDesign-топиарные фигуры": "топиарные фигуры",
  "applicationInDesign-фитопластика": "фитопластика",
  "applicationInDesign-флористический дизайн": "флористический дизайн",
  "applicationInDesign-шпалера": "шпалера",
  "applicationInDesign-японский сад": "японский сад",

  "disease-альтернариоз": "альтернариоз",
  "disease-антракноз": "антракноз",
  "disease-астровый вилт": "астровый вилт",
  "disease-бактериальный ожог": "бактериальный ожог",
  "disease-бактериальная рябуха": "бактериальная рябуха",
  "disease-белая гниль": "белая гниль",
  "disease-белая пятнистость": "белая пятнистость",
  "disease-биаторелловый рак тиса": "биаторелловый рак тиса",
  "disease-бурая пятнистость": "бурая пятнистость",
  "disease-вертициллез": "вертициллез",
  "disease-вершинная гниль": "вершинная гниль",
  "disease-вирус люцерновой мозаики": "вирус люцерновой мозаики",
  "disease-вирус мозаики": "вирус мозаики",
  "disease-вирус некротической полосатости лилии": "вирус некротической полосатости лилии",
  "disease-вирус хосты X": "вирус хосты X",
  "disease-водянистая гниль": "водянистая гниль",
  "disease-гниль стебля": "гниль стебля",
  "disease-грибковые заболевания": "грибковые заболевания",
  "disease-кила капустных": "кила капустных",
  "disease-клястероспориоз": "клястероспориоз",
  "disease-корневая гниль": "корневая гниль",
  "disease-корневой рак": "корневой рак",
  "disease-ложная мучнистая роса": "пероноспороз (ложная мучнистая роса)",
  "disease-мозаичная болезнь листьев": "мозаичная болезнь листьев",
  "disease-мокрая бактериальная гниль": "мокрая бактериальная гниль",
  "disease-монтарь": "монтарь",
  "disease-мучнистая роса": "мучнистая роса",
  "disease-огуречная мозаика": "огуречная мозаика",
  "disease-оидиум винограда": "оидиум винограда",
  "disease-парша": "парша",
  "disease-пенициллез": "пенициллез",
  "disease-песталоциевый некроз": "песталоциевый некроз",
  "disease-пестролепестность": "пестролепестность",
  "disease-плодовая гниль (монилиоз)": "плодовая гниль (монилиоз)",
  "disease-подгар табака": "подгар табака",
  "disease-пожилковый хлороз": "пожилковый хлороз",
  "disease-пятнистость листьев": "пятнистость листьев",
  "disease-рак": "рак",
  "disease-рассадная (стеблевая) гниль": "рассадная (стеблевая) гниль",
  "disease-реверсия черной смородины": "реверсия черной смородины",
  "disease-ржавчина": "ржавчина",
  "disease-ризоктониоз (бурая гниль)": "ризоктониоз (бурая гниль)",
  "disease-сажистый гриб": "сажистый гриб",
  "disease-серая гниль": "серая гниль",
  "disease-серая плесень": "серая плесень",
  "disease-стаганоспороз": "стаганоспороз",
  "disease-стволовая гниль": "стволовая гниль",
  "disease-табачная мозаика": "табачная мозаика",
  "disease-у- вирус картофеля (белая пестрица)": "у- вирус картофеля (белая пестрица)",
  "disease-фитофтороз": "фитофтороз",
  "disease-фомоз тиса": "фомоз тиса",
  "disease-фомоз": "фомоз",
  "disease-фузариоз": "фузариоз",
  "disease-фузариозная пятнистость": "фузариозная пятнистость",
  "disease-фузариозное увядание": "фузариозное увядание",
  "disease-хлороз": "хлороз",
  "disease-церкоспороз": "церкоспороз",
  "disease-черная ножка": "черная ножка",
  "disease-черная пятнистость": "черная пятнистость",
  "disease-чернь": "чернь",
  "disease-шютте бурое": "шютте бурое",

  "pests-белокрылка": "белокрылка",
  "pests-блошка крестоцветная": "блошка крестоцветная",
  "pests-войлочный ореховый клещ": "войлочный ореховый клещ",
  "pests-галлицы": "галлицы",
  "pests-гороховая зерновка": "гороховая зерновка",
  "pests-гусеницы": "гусеницы",
  "pests-долгоносик": "долгоносик",
  "pests-еловая листовертка-иглоед": "еловая листовертка-иглоед",
  "pests-зонтичная моль": "зонтичная моль",
  "pests-капустная гусеница": "капустная гусеница",
  "pests-капустная муха": "капустная муха",
  "pests-клоп вонючий": "клоп вонючий",
  "pests-колорадский жук": "колорадский жук",
  "pests-комары-долгоножки": "комары-долгоножки",
  "pests-корневой луковый клещ": "корневой луковый клещ",
  "pests-крестоцветная блошка": "крестоцветная блошка",
  "pests-крот": "крот",
  "pests-лилейная муха": "лилейная муха",
  "pests-лилейный жук": "лилейный жук",
  "pests-листоблошка": "листоблошка",
  "pests-листовая блошка": "листовая блошка",
  "pests-листовертка": "листовертка",
  "pests-листоеды": "листоеды",
  "pests-луковая журчалка": "луковая журчалка",
  "pests-луковый клещ": "луковый клещ",
  "pests-малинный жук": "малинный жук",
  "pests-медведка": "медведка",
  "pests-морковная муха": "морковная муха",
  "pests-минирующая муха": "минирующая муха",
  "pests-муравьи": "муравьи",
  "pests-мучнистый червец": "мучнистый червец",
  "pests-мягкая ложнощитовка": "мягкая ложнощитовка",
  "pests-нематоды": "нематоды",
  "pests-огневка": "огневка",
  "pests-паутинный клещ": "паутинный клещ",
  "pests-пилильщик": "пилильщик",
  "pests-плодожорка": "плодожорка",
  "pests-полевая мышь": "полевая мышь",
  "pests-полевой клоп": "полевой клоп",
  "pests-полосатый долгоносик": "полосатый долгоносик",
  "pests-почковый клещ": "почковый клещ",
  "pests-проволочник": "проволочник",
  "pests-растительноядный клещ": "растительноядный клещ",
  "pests-самшитовая огневка": "самшитовая огневка",
  "pests-сельдерейная муха": "сельдерейная муха",
  "pests-слизни": "слизни",
  "pests-слюнявая пенница": "слюнявая пенница",
  "pests-стеблевая нематода": "стеблевая нематода",
  "pests-табачный проволочник": "табачный проволочник",
  "pests-тисовая галлица": "тисовая галлица",
  "pests-тисовая ложнощитовка": "тисовая ложнощитовка",
  "pests-тисовая плоскотелка": "тисовая плоскотелка",
  "pests-тисовый почковый клещ": "тисовый почковый клещ",
  "pests-тля": "тля",
  "pests-трипсы": "трипсы",
  "pests-тюльпановая огнёвка": "тюльпановая огнёвка",
  "pests-улитки": "улитки",
  "pests-фасолевая зерновка": "фасолевая зерновка",
  "pests-хрущ": "хрущ",
  "pests-цветочная пяденица": "цветочная пяденица",
  "pests-щитовка": "щитовка",

  "pesticideTreatmentFrequency-1 раз в неделю": "1 раз в неделю",
  "pesticideTreatmentFrequency-2 раза в неделю": "2 раза в неделю",
  "pesticideTreatmentFrequency-1 раз в месяц": "1 раз в месяц",
  "pesticideTreatmentFrequency-2 раза в месяц": "2 раза в месяц",
  "pesticideTreatmentFrequency-1 раз за сезон": "1 раз за сезон",
  "pesticideTreatmentFrequency-по мере необходимости": "по мере необходимости",
  "pesticideTreatmentFrequency-при определенных условиях": "при определенных условиях",

  "fertilizerFrequency-1 раз в неделю": "1 раз в неделю",
  "fertilizerFrequency-2 раза в неделю": "2 раза в неделю",
  "fertilizerFrequency-1 раз в 2 недели": "1 раз в 2 недели",
  "fertilizerFrequency-1 раз в месяц": "1 раз в месяц",
  "fertilizerFrequency-2 раза в месяц": "2 раза в месяц",
  "fertilizerFrequency-1 раз в месяц в вегетационный период": "1 раз в месяц в вегетационный период",
  "fertilizerFrequency-2 раза в месяц в вегетационный период": "2 раза в месяц в вегетационный период",
  "fertilizerFrequency-1 раз за сезон": "1 раз за сезон",
  "fertilizerFrequency-2 раза за сезон": "2 раза за сезон",
  "fertilizerFrequency-3-4 раза за сезон": "3-4 раза за сезон",
  "fertilizerFrequency-при определенных условиях": "при определенных условиях",

  "elementName-building": "building",
  "elementName-building1": "building 1",
  "elementName-building2": "building 2",
  "elementName-building3": "building 3",
  "elementName-building4": "building 4",
  "elementName-building5": "building 5",
  "elementName-building6": "building 6",
  "elementName-building7": "building 7",
  "elementName-building8": "building 8",
  "elementName-building9": "building 9",
  "elementName-building10": "building 10",
  "elementName-building11": "building 11",
  "elementName-building12": "building 12",
  "elementName-building13": "building 13",
  "elementName-building14": "building 14",
  "elementName-building15": "building 15",
  "elementName-building16": "building 16",
  "elementName-building17": "building 17",
  "elementName-building18": "building 18",

  "elementName-garden": "garden",

  "elementName-lawn": "lawn",

  "elementName-flowerbed": "flower bed",
  "elementName-flowerbed1": "square flower bed",
  "elementName-flowerbed2": "round flower bed",
  "elementName-flowerbed11": "square flower bed",
  "elementName-flowerbed22": "round flower bed",

  "elementName-greenhouse": "greenhouse",
  "elementName-greenhouse1": "greenhouse1",

  "elementName-vegetablegarden": "veg garden",
  "elementName-veggardencabbage": "veg garden cabbage",
  "elementName-veggarden11": "veg garden 11",
  "elementName-veggarden12": "veg garden 12",
  "elementName-veggarden2": "veg garden 2",
  "elementName-veggarden4": "veg garden 4",
  "elementName-veggarden7": "veg garden 7",
  "elementName-veggarden26": "veg garden 26",

  "elementName-tile": "tile",
  "elementName-tile1": "tile 1",
  "elementName-tile2": "tile 2",
  "elementName-tile3": "tile 3",
  "elementName-tile4": "tile 4",
  "elementName-tile5": "tile 5",
  "elementName-tile6": "tile 6",

  "elementName-stairs": "stairs",
  "elementName-stairs1": "stairs 1",
  "elementName-stairs2": "stairs 2",

  "elementName-terrace": "terrace",
  "elementName-terrace1": "terrace 1",

  "elementName-patio": "patio",
  "elementName-patio1": "patio 1",
  "elementName-patio2": "patio 2",

  "elementName-fence": "fence",
  "elementName-fence1": "fence 1",
  "elementName-fence2": "fence 2",
  "elementName-fence3": "fence 3",
  "elementName-fence4": "fence 4",

  "elementName-entrance": "entrance",
  "elementName-gate1": "double gate",
  "elementName-gate2": "single gate",
  "elementName-wicket": "wicket",

  "elementName-plantcomposition": "plant composition",

  "elementName-rockery1": "rockery 1",
  "elementName-rockery2": "rockery 2",
  "elementName-rockery3": "rockery 3",

  "elementName-tree": "tree",
  "elementName-bush": "bush",
  "elementName-redBush": "red bush",
  "elementName-grass": "grass",

  "elementName-structure": "structure",
  "elementName-gazebo1": "gazebo 1",

  "elementName-pathway": "pathway",
  "elementName-pathway1": "pathway 1",
  "elementName-pathway2": "pathway 2",
  "elementName-pathway3": "pathway 3",
  "elementName-pathway4": "pathway 4",
  "elementName-pathway5": "pathway 5",
  "elementName-pathway6": "pathway 6",
  "elementName-pathway7": "pathway 7",
  "elementName-pathway8": "pathway 8",
  "elementName-pathway9": "pathway 9",
  "elementName-pathway10": "pathway 10",
  "elementName-pathway11": "pathway 11",
  "elementName-pathway12": "pathway 12",
  "elementName-pathway13": "pathway 13",
  "elementName-pathway14": "pathway 14",

  "elementName-court": "court",
  "elementName-court1": "court 1",
  "elementName-court2": "court 2",

  "elementName-hedge": "hedge",
  "elementName-hedge1": "hedge 1",
  "elementName-hedge2": "hedge 2",
  "elementName-hedge3": "hedge 3",
  "elementName-hedge4": "hedge 4",
  "elementName-hedge5": "hedge 5",
  "elementName-hedge6": "hedge 6",

  "elementName-tree1": "tree 1",
  "elementName-treeapple": "fruit tree",
  "elementName-bush3": "bush",
  "elementName-bush4": "bush",
  "elementName-bush6": "bush",
  "elementName-bush7": "bush",
  "elementName-grass_gray": "gray grass",
  "elementName-carex": "carex",
  "elementName-bushflowersorange": "bush with orange flowers",
  "elementName-bushflowersred": "bush with red flowers",
  "elementName-boxwoodball": "ball",
  "elementName-cabbage": "cabbage",
  "elementName-carrot": "carrot",
  "elementName-eggplant": "eggplant",
  "elementName-beet": "beet",
  "elementName-onion": "onion",
  "elementName-salad": "salad",

  "elementName-pool": "pool",
  "elementName-waterpool1": "waterpool 1",
  "elementName-waterpool2": "waterpool 2",
  "elementName-waterpool3": "waterpool 3",
  "elementName-waterpool4": "waterpool 4",
  "elementName-waterpool5": "waterpool 5",
  "elementName-waterpool6": "waterpool 6",
  "elementName-waterpool7": "waterpool 7",
  "elementName-waterpool8": "waterpool 8",
  "elementName-waterpool9": "waterpool 9",

  "elementName-water": "water element",
  "elementName-fountain1": "fountain 1",
  "elementNamewaterfall2": "waterfall 2",

  "elementName-stone1": "stone 1",
  "elementName-stone2": "stone 2",
  "elementName-stone3": "stone 3",
  "elementName-stone4": "stone 4",
  "elementName-flowerpot1": "flower pot",
  "elementName-turtle": "turtle",
  "elementName-car1": "car",

  "elementName-sofa1": "sofa",
  "elementName-chair1": "chair",
  "elementName-table1": "table",

  "elementName-lampball": "lamp ball",
  "elementName-lamp": "lamp",
  "elementName-spotlight": "spotlight"
}
